import definition from './feedback.service';

export default {
    name: 'FeedbackApi',
    definition
};



// WEBPACK FOOTER //
// ./app/services/api/feedback/index.js